import { getHazardColor, getHazardIcon, getHazardName } from "@/features/branding";
import { AnaHazardId } from "@/store/services/facades/types";
import { RCP_COLORS } from "@/types/rcp";
import { SquareIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useCollectionState } from "../context/CollectionContext";
const CollectionFiltersLabel = ({
  withIcons = false,
  rcpSize = "short"
}: {
  withIcons?: boolean;
  rcpSize?: "short" | "medium" | "long";
}) => {
  const {
    t
  } = useTranslation("terms");
  const {
    rcp,
    hazard,
    year
  } = useCollectionState();
  const rcpName = t(`scenarios.${rcp}.${rcpSize}`);
  const hazardName = getHazardName(hazard);
  if (withIcons) {
    return <span className="inline-flex flex-wrap items-center gap-x-1 gap-y-0">
        {getHazardIcon(hazard as AnaHazardId, {
        style: {
          color: getHazardColor(hazard as AnaHazardId),
          fontSize: 18
        }
      })}
        <span>{hazardName},</span>
        <SquareIcon weight="fill" color={RCP_COLORS[rcp]} />
        <span>{rcpName},</span>
        <span>{year}</span>
      </span>;
  }
  return <span className="text-xs font-medium text-gray-400" data-sentry-component="CollectionFiltersLabel" data-sentry-source-file="CollectionFiltersLabel.tsx">
      {rcpName}, {hazardName}, {year}
    </span>;
};
export default CollectionFiltersLabel;